import React from 'react';

const Footer = () => {
  return (
    <div className="bg-[#d6daf0] border-t border-[#34345c] p-5">
      <div className=" flex justify-center">
        <p className="font-bold text-[#34345c]">
          Developed by{' '}
          <a href="https://cippitech.vercel.app/" target="_blank" className='underline'>
            Marco Cippitelli
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
